window.addEventListener('DOMContentLoaded', (event)=>{
    ($ => {
        $(document).ready(
        (() => {
            let lastUrl = location.href;
            new MutationObserver(() => {
                const url = location.href;
                if (url !== lastUrl) {
                    lastUrl = url;
                    //onUrlChange();
                }
            }).observe(document, { subtree: true, childList: true });
            const updateUrlParam = function (param, value) {
                const url = new URL(window.location);
                url.searchParams.set(param, value);
                window.history.replaceState({}, '', url);
            }
            // process the page heading
            const the_heading = $('.product__title').text();

            // if (the_heading) {
            //     $('.product__title').html(the_heading.split('-')[0] + "<span class='js-sub-heading'>" + the_heading.split('-')[1] + '<span title = "Share this custom table"><svg style = "cursor: pointer;"id = "share-this-product"<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"width="24" height="24"viewBox="0 0 24 24"style=" fill:#000000;"><path d="M 18 2 C 16.35499 2 15 3.3549904 15 5 C 15 5.1909529 15.021791 5.3771224 15.056641 5.5585938 L 7.921875 9.7207031 C 7.3985399 9.2778539 6.7320771 9 6 9 C 4.3549904 9 3 10.35499 3 12 C 3 13.64501 4.3549904 15 6 15 C 6.7320771 15 7.3985399 14.722146 7.921875 14.279297 L 15.056641 18.439453 C 15.021555 18.621514 15 18.808386 15 19 C 15 20.64501 16.35499 22 18 22 C 19.64501 22 21 20.64501 21 19 C 21 17.35499 19.64501 16 18 16 C 17.26748 16 16.601593 16.279328 16.078125 16.722656 L 8.9433594 12.558594 C 8.9782095 12.377122 9 12.190953 9 12 C 9 11.809047 8.9782095 11.622878 8.9433594 11.441406 L 16.078125 7.2792969 C 16.60146 7.7221461 17.267923 8 18 8 C 19.64501 8 21 6.6450096 21 5 C 21 3.3549904 19.64501 2 18 2 z M 18 4 C 18.564129 4 19 4.4358706 19 5 C 19 5.5641294 18.564129 6 18 6 C 17.435871 6 17 5.5641294 17 5 C 17 4.4358706 17.435871 4 18 4 z M 6 11 C 6.5641294 11 7 11.435871 7 12 C 7 12.564129 6.5641294 13 6 13 C 5.4358706 13 5 12.564129 5 12 C 5 11.435871 5.4358706 11 6 11 z M 18 18 C 18.564129 18 19 18.435871 19 19 C 19 19.564129 18.564129 20 18 20 C 17.435871 20 17 19.564129 17 19 C 17 18.435871 17.435871 18 18 18 z"></path></svg></span></span>');
            //     $('.product__title').css("font-weight", "bold");
            // }
            updateAddtionalWidth();
            updateAddtionalLength();
            updateFinishLevel();
            handleCheckOut();
            $(".width-select").change(function (e) {
                updateAddtionalWidth();
                updateVariant();
            });
            $(".diameter-select").change(function(e) {
                updateVariant();
            });
            $(".length-select").change(function (e) {
                updateAddtionalLength();
                updateVariant();
            });
            $(".finish-level-select").change(function (e) {
                updateFinishLevel();
                updateVariant();
            });
            const urlSearchParams = new URLSearchParams(window.location.search);
            urlSearchParams.forEach(function (value, key) {
                // set the values from the url for preset variables
                const $element = jQuery('#' + key);
                $element.val(value);
                // trigger the change handler function
                $element.change();
            });

            // bind selects to update the url params on change
            jQuery("#product-variant-select-container").find('.js-dynamic-field').change((event) => {
                const $element = jQuery(event.target);
                updateUrlParam($element.attr('id'), $element.val());
            });

            // bind share button 
            jQuery("#share-this-product").click(function () {
                const shareData = {
                    title: 'LumberShack Custom Product',
                    text: 'LumberShack Custom Product',
                    url: window.location,
                }

                navigator.share(shareData);
            });
        })());

        function updateVariant(){
            const hiddenSelect = $('#hidden-custom-table-top-select');
            const valueToSelect = $(".width-select").val() + " / " + $(".length-select").val() + " / " + $(".finish-level-select").val();
            const valueToSelectDiameter = $(".diameter-select").val() + " / " + $('.finish-level-select').val();
            const addToCartButton = $('#product-add-to-cart-button');
            const addToCartButtonSticky1 = $('#product-add-to-cart-button-sticky-1');
            const addToCartButtonSticky2 = $('#product-add-to-cart-button-sticky-2');

            var optionFound = false;
            hiddenSelect.find('option').each(function() {
                if (this.text === valueToSelect || this.text === valueToSelectDiameter) {
                    $(this).prop('selected', true);
                    optionFound = true;
                    return false;
                }
            });

            if(optionFound) {
                addToCartButton?.prop('disabled', false).text('Add to cart');
                addToCartButtonSticky1?.prop('disabled', false).text('Add to cart');
                addToCartButtonSticky2?.prop('disabled', false).text('Add to cart');
                
                const selectedOption = hiddenSelect.find('option:selected');
                const selectedVariant = selectedOption.val();
                const price = selectedOption.data('variant-price');
                const compareAtPrice = selectedOption.data('variant-compare-at-price');

                variantPrice = parseFloat(price.replace(/[^0-9.]/g, ''));
                variantCompareAtPrice = parseFloat(compareAtPrice.replace(/[^0-9.]/g, ''));

                const url = new URL(window.location);
                url.searchParams.set('variant', selectedVariant);
                window.history.replaceState({}, '', url);

                $('#booster-hidden-variant-input').val(selectedVariant);

                if(typeof window.calculateAddonPrice === 'function') {
                    window.calculateAddonPrice();
                } else {
                    $('.product-total-compare-at-price').each(function() {
                        $(this).text(compareAtPrice);
                    });
    
                    $('.product-total-price').each(function() {
                        $(this).text(price);
                    });
                }
            } else {
                addToCartButton?.prop('disabled', true).text('Unavailable');
                addToCartButtonSticky1?.prop('disabled', true).text('Unavailable');
                addToCartButtonSticky2?.prop('disabled', true).text('Unavailable');
            }

        }

        function onUrlChange() {
            const updateUrlParam = function (param, value) {
                const url = new URL(window.location);
                url.searchParams.set(param, value);
                window.history.replaceState({}, '', url);
            }
            $('.js-dynamic-field').each(function (index, element) {
                const $element = $(element);
                updateUrlParam($element.attr('id'), $element.val());
            });
        }

        function updateAddtionalWidth() {

            const generate_option_text = function (option_value_number) {
                if (option_value_number === parseInt(option_value_number, 10)) {
                    return option_value_number.toString() + '"';
                }
                return `${Math.trunc(option_value_number)} 1/2"`;
            };
            const generate_select_options = function (range_start, range_end, step = .5) {
                if (range_start === range_end) return '';

                let current_option_number = range_start + step;
                let current_option_text = generate_option_text(current_option_number);
                let out_options = '';

                while (current_option_number < range_end) {
                    out_options += `<option value="${current_option_text}">${current_option_text}</option>`;
                    current_option_number += step;
                    current_option_text = generate_option_text(current_option_number);
                }

                return out_options;
            };

            const $widthSelect = $(".width-select");
            const $addtionalWidthSelect = $('#product-additional-width');
            const widthSelectedOptionIndex = $widthSelect.prop('selectedIndex');
            const widthSelectedOption = parseInt($widthSelect.val());
            const widthPreviousOption = parseInt($widthSelect.find('option').eq(widthSelectedOptionIndex - 1).val());
            const widthOptions = generate_select_options(widthPreviousOption, widthSelectedOption);
            $addtionalWidthSelect.empty();
            if (widthOptions === '') {
                $addtionalWidthSelect.append('<option value="Not Available">Not Available</option>');
            } else {
                $addtionalWidthSelect.append('<option value="No Change in Width">No Change in Width</option>').append(widthOptions);
            }

        }

        function updateAddtionalLength() {
            const generate_option_text = function (option_value_number) {
                if (option_value_number === parseInt(option_value_number, 10)) {
                    return option_value_number.toString() + '"';
                }
                return `${Math.trunc(option_value_number)} 1/2"`;
            };
            const generate_select_options = function (range_start, range_end, step = .5) {
                if (range_start === range_end) return '';

                let current_option_number = range_start + step;
                let current_option_text = generate_option_text(current_option_number);
                let out_options = '';

                while (current_option_number < range_end) {
                    out_options += `<option value="${current_option_text}">${current_option_text}</option>`;
                    current_option_number += step;
                    current_option_text = generate_option_text(current_option_number);
                }

                return out_options;
            };
            const $lengthSelect = $(".length-select");

            const $addtionalLengthSelect = $('#product-additional-length');

            const lengthSelectedOptionIndex = $lengthSelect.prop('selectedIndex');
            const lengthSelectedOption = parseInt($lengthSelect.val());
            const lengthPreviousOption = parseInt($lengthSelect.find('option').eq(lengthSelectedOptionIndex - 1).val());

            $addtionalLengthSelect.empty();
            const lengthOptions = generate_select_options(lengthPreviousOption, lengthSelectedOption, 1);
            if (lengthOptions === '') {
                $addtionalLengthSelect.append('<option value="Not Available">Not Available</option>');
            } else {
                $addtionalLengthSelect.append('<option value="No Change in Length">No Change in Length</option>').append(lengthOptions);
            }

        }

        function updateFinishLevel() {
            const $finishLevelSelect = $(".finish-level-select");
            const $sandingFinish = $('#product-sanding-finish');

            $sandingFinish.empty();

            if ($finishLevelSelect.val() === 'Unfinished/DIY') {
                $sandingFinish.empty().append('<option value="Not Available">Not Available</option>');
            } else {
                $sandingFinish.empty().append('<option value="Smooth Flat Surface">Smooth Flat Surface</option><option value="Rustic Grinder Finish">Rustic Grinder Finish</option>');
            }

        }
        /**
         *  when add to cart button is clicked it checks if agree to terms check box is checked and then 
         *  adds hidden inputs for each of the additional dynamic selectors
         */
        function handleCheckOut() {

            const $atcButton = $('#product-atc-btn');
            const $agreeTerms = $('#agree-terms');
            $atcButton.click(function () {
                // make sure terms and conditions agreement is checked
                if (!$agreeTerms.is(":checked")) {
                    alert("Please agree to the terms and conditions!");
                    return false;
                }
                // add inputs to the form 
                const variantInputsWrapper = jQuery("#product-variant-select-container");
                $(".dynamic-input").remove();
                // create hidden inputs for all of our marked selects
                $('.js-dynamic-field').each(function (index, element) {
                    const label_text = $("label[for='" + $(element).attr('id') + "']").text();
                    const value = $(element).val();
                    variantInputsWrapper.append(`<input class="dynamic-input" type="hidden" name="properties[${label_text}]" value="${value}"/>`);
                });
            });
        }

        function handleParams() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            urlSearchParams.forEach(function (value, key) {
                // set the values from the url for preset variables
                const $element = jQuery('#' + key);
                $element.val(value);
                // trigger the change handler function
                $element.change();
            });

            // bind selects to update the url params on change
            jQuery("#product-variants").find('select').change((event) => {
                const $element = jQuery(event.target);
                updateUrlParam($element.attr('id'), $element.val());
            });

            // bind share button 
            jQuery("#share-this-product").click(function () {
                const shareData = {
                    title: 'LumberShack Custom Product',
                    text: 'LumberShack Custom Product',
                    url: window.location,
                }

                navigator.share(shareData);
            });
        }
    })(jQuery);
});